import { Icon } from "@ui/Icon";
import { getPlatformIcon } from "@utils/platform";

export { getPlatformIcon, normalizePlatform } from "@utils/platform";

import "./BrandIcon.css";

export const BrandIcon = (props: {
	platform: string;
	class?: string;
	width?: string;
	height?: string;
	fillWithCurrentColor?: boolean;
	glyphOnly?: boolean;
	background?: "none" | "circle" | "square";
}) => {
	const icon = getPlatformIcon(props.platform);
	if (!icon) {
		return null;
	}
	if (props.background === "circle") {
		return (
			<div class={`gvt-ui-brand-icon circle ${props.platform}`}>
				<Icon
					icon={icon}
					class={props.class}
					width={props.width ?? "1rem"}
					height={props.height ?? "1rem"}
					fillWithCurrentColor={props.fillWithCurrentColor ?? false}
					glyphOnly={props.glyphOnly}
				/>
			</div>
		);
	}
	if (props.background === "square") {
		return (
			<div class={`gvt-ui-brand-icon square ${props.platform}`}>
				<Icon
					icon={icon}
					class={props.class}
					width={props.width ?? "1rem"}
					height={props.height ?? "1rem"}
					fillWithCurrentColor={props.fillWithCurrentColor ?? false}
					glyphOnly={props.glyphOnly}
				/>
			</div>
		);
	}
	return (
		<Icon
			icon={icon}
			class={props.class}
			width={props.width ?? "1rem"}
			height={props.height ?? "1rem"}
			fillWithCurrentColor={props.fillWithCurrentColor ?? false}
			glyphOnly={props.glyphOnly}
		/>
	);
};
